import React, { ChangeEvent, Component, FormEvent } from "react";
import { RouteComponentProps } from "react-router-dom";
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardGroup,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row,
  Spinner,
} from "reactstrap";
import droopleLogo from "../../assets/img/brand/LogoDropOnlyBlueTranspSmall.png";

import Auth from "../../components/AuthService";
import Announces from "../../components/Announces";
import { withTranslation } from "react-i18next";
import { LegacyWithTranslationProps } from "../../locales/LegacyWithTranslationProps";
import { i18NextNamespaces } from "../../i18n";
import { APP_LOCAL_STORAGE_LOGIN_SCREEN_LOGO } from "../../helpers/Constants";
import AuthService from "../../components/AuthService";

class Login extends Component<
  RouteComponentProps & LegacyWithTranslationProps,
  {
    error: string;
    invalid: boolean;
    email: string;
    redirectToReferrer: boolean;
    password: string;
    loading: boolean;
    validEmail: boolean;
    logo: string | undefined;
    needsPasswordReset: boolean;
  }
> {
  constructor(props: RouteComponentProps & LegacyWithTranslationProps) {
    super(props);
    this.state = {
      redirectToReferrer: false,
      email: new URLSearchParams(this.props.location.search).get("email") || "",
      password:
        new URLSearchParams(this.props.location.search).get("password") || "",
      invalid: false,
      error: "",
      loading: false,
      validEmail: false,
      logo:
        localStorage.getItem(APP_LOCAL_STORAGE_LOGIN_SCREEN_LOGO) ||
        droopleLogo,
      needsPasswordReset: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.login = this.login.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.onNextButtonClicked = this.onNextButtonClicked.bind(this);
  }

  _getRedirect() {
    return new URLSearchParams(this.props.location.search).get("redirect");
  }

  componentDidMount() {
    if (this.state.email && this.state.password) {
      this.login();
    } else if (Auth.loggedIn()) {
      this.props.history.replace(this._getRedirect() || "/");
    }
  }

  login(e?: FormEvent<any>) {
    // First we need to ensure that no one is logged in
    if (Auth.loggedIn()) {
      Auth.logout();
    }
    const { t } = this.props;
    if (e) {
      e.preventDefault();
    }
    this.setState({ loading: true });
    Auth.signin(
      this.state.email,
      this.state.password,
      () => {
        this.props.history.push(this._getRedirect() || "/");
      },
      (error: { code: string; message: string }) => {
        const code = error.code;
        switch (code) {
          case "ProfileWithoutClient":
            this.setState({
              error: t("error.profileWithoutClient"),
              invalid: true,
            });
            break;
          case "ProfileDisabled":
            this.setState({
              error: t("error.profileDisabled"),
              invalid: true,
            });
            break;
          case "UserNotConfirmedException":
            this.props.history.push(
              "/verify?email=" + encodeURIComponent(this.state.email)
            );
            break;
          case "NotAuthorizedException":
            this.setState({
              error: error.message,
              invalid: true,
              loading: false,
            });
            break;
          default:
            this.setState({
              error: error.message,
              invalid: true,
              loading: false,
            });
            break;
        }
      }
    );
  }

  handleEmailChange(event: ChangeEvent<any>) {
    this.setState({ email: event.target.value });
  }

  handlePasswordChange(event: ChangeEvent<any>) {
    this.setState({ password: event.target.value });
  }

  async onNextButtonClicked(_event: ChangeEvent<any>) {
    // First we need to ensure that no one is logged in
    if (Auth.loggedIn()) {
      Auth.logout();
    }
    const { t } = this.props;
    this.setState({ loading: true });

    // Ask the backend for the user status
    // For some clients, we will have some custom URLs needed for SSO, bypassing the normal password auth
    const userStatus = await AuthService.getUserStatus(
      encodeURIComponent(this.state.email)
    );

    if (userStatus && userStatus.status === "SSO_REDIRECT" && userStatus.data) {
      window.location.replace(userStatus.data);
      return;
    }
    if (userStatus && userStatus.status === "NEEDS_PASSWORD_RESET") {
      this.setState({ needsPasswordReset: true, loading: false });
      return;
    }

    Auth.signin(
      this.state.email,
      this.state.password ??
        "01100010 01100001 01110011 01110100 01101001 01100101 01101110",
      () => {
        this.props.history.push(this._getRedirect() || "/");
      },
      (error: { code: string; message: string }) => {
        const code = error.code;
        this.setState({ loading: false });
        switch (code) {
          case "UserNotFoundException":
            const redirect = this._getRedirect();
            if (redirect !== null) {
              this.props.history.push(
                "/register?redirect=" +
                  encodeURIComponent(redirect) +
                  "&email=" +
                  encodeURIComponent(this.state.email)
              );
            } else {
              this.props.history.push(
                "/register?email=" + encodeURIComponent(this.state.email)
              );
            }
            break;
          case "UserNotConfirmedException":
            this.props.history.push(
              "/verify?email=" + encodeURIComponent(this.state.email)
            );
            break;
          case "NotAuthorizedException":
            if (error.message === "Incorrect username or password.") {
              this.setState({ validEmail: true });
            } else {
              this.setState({
                error: error.message,
                invalid: true,
              });
            }
            break;
          case "ProfileWithoutClient":
            this.setState({
              error: t("error.profileWithoutClient"),
              invalid: true,
            });
            break;
          default:
            this.setState({
              error: error.message,
              invalid: true,
            });
            break;
        }
      }
    );
  }

  handleSubmit(event: FormEvent) {
    event.preventDefault();
    this.setState({ invalid: false });
    if (!this.state.validEmail) {
      this.onNextButtonClicked(event);
    } else {
      this.login(event);
    }
  }

  render() {
    const { t } = this.props;
    return (
      <div>
        <div className="position-absolute w-100">
          <Announces />
        </div>
        <div className="app flex-row align-items-center login-view">
          <Container>
            <Row className="justify-content-center">
              <Col md="6">
                {/*8 with signin*/}
                <CardGroup className="login-box">
                  <Card className="p-4">
                    <CardBody>
                      <Form onSubmit={this.handleSubmit}>
                        <FormGroup>
                          <img
                            src={this.state.logo}
                            alt="Droople"
                            className="mx-auto d-block img-fluid"
                          />
                          <h1>{t("display.login")}</h1>
                          <p className="text-muted">{t("display.signIn")}</p>
                          {this.state.needsPasswordReset ? (
                            <Alert color="warning">
                              <h4>{t("display.passwordResetRequired")}</h4>
                              <p className="small-bottom-margin">
                                {t("display.passwordResetRequiredMessage")}
                              </p>
                              <Button
                                color="primary"
                                className="small-bottom-margin"
                                onClick={() => {
                                  this.props.history.push(
                                    "/reset-password?redirect=" +
                                      encodeURIComponent(
                                        this._getRedirect() || "/"
                                      ) +
                                      "&email=" +
                                      encodeURIComponent(this.state.email)
                                  );
                                }}
                              >
                                {t("display.resetPassword")}
                              </Button>
                              <p className="no-bottom-margin">
                                {t("display.passwordResetRequiredThanks")}
                              </p>
                            </Alert>
                          ) : (
                            <>
                              <InputGroup className="mb-3">
                                <InputGroupAddon addonType="prepend">
                                  <InputGroupText>
                                    <i className="fa fa-user" />
                                  </InputGroupText>
                                </InputGroupAddon>
                                <Input
                                  type="text"
                                  placeholder={this.props.t("display.email")}
                                  autoComplete="email"
                                  value={this.state.email}
                                  onChange={this.handleEmailChange}
                                />
                              </InputGroup>
                              <InputGroup
                                className="mb-4"
                                hidden={!this.state.validEmail}
                              >
                                <InputGroupAddon addonType="prepend">
                                  <InputGroupText>
                                    <i className="fa fa-lock" />
                                  </InputGroupText>
                                </InputGroupAddon>
                                <Input
                                  type="password"
                                  placeholder={this.props.t("display.password")}
                                  autoComplete="current-password"
                                  value={this.state.password}
                                  onChange={this.handlePasswordChange}
                                />
                              </InputGroup>
                              {this.state.invalid ? (
                                <p className="text-danger">
                                  {this.state.error}
                                </p>
                              ) : null}
                              <Row>
                                <Col>
                                  {this.state.validEmail ? (
                                    <>
                                      <Button
                                        color="link"
                                        className="px-0 ml-3 float-left"
                                        onClick={() =>
                                          this.props.history.push(
                                            "/reset-password?redirect=" +
                                              encodeURIComponent(
                                                this._getRedirect() || "/"
                                              ) +
                                              "&email=" +
                                              encodeURIComponent(
                                                this.state.email
                                              )
                                          )
                                        }
                                      >
                                        {t("display.forgotPassword")}
                                      </Button>
                                    </>
                                  ) : (
                                    <Button
                                      color="link"
                                      className="px-0 ml-3 float-left"
                                      onClick={() => {
                                        const redirect = this._getRedirect();
                                        if (redirect !== null) {
                                          this.props.history.push(
                                            "/register?redirect=" +
                                              encodeURIComponent(redirect)
                                          );
                                        } else {
                                          this.props.history.push("/register");
                                        }
                                      }}
                                    >
                                      {t("display.createAccount")}
                                    </Button>
                                  )}
                                  {this.state.loading ? (
                                    <Spinner
                                      size="md"
                                      className="float-right"
                                    />
                                  ) : (
                                    <Button
                                      color="primary"
                                      className="px-4 float-right"
                                      type="submit"
                                    >
                                      {this.state.validEmail
                                        ? t(`${i18NextNamespaces.COMMON}:login`)
                                        : t(`${i18NextNamespaces.COMMON}:next`)}
                                    </Button>
                                  )}
                                </Col>
                              </Row>
                            </>
                          )}
                        </FormGroup>
                      </Form>
                    </CardBody>
                  </Card>
                </CardGroup>
              </Col>
            </Row>
          </Container>
        </div>{" "}
      </div>
    );
  }
}

export default withTranslation(i18NextNamespaces.LOGIN)(Login);
